export default "__VITE_ASSET__At_F_KBU__"